import { render } from "./BurgerMenu.vue?vue&type=template&id=08872cf0&scoped=true"
import script from "./BurgerMenu.vue?vue&type=script&lang=js"
export * from "./BurgerMenu.vue?vue&type=script&lang=js"

import "./BurgerMenu.vue?vue&type=style&index=0&id=08872cf0&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08872cf0"]])

export default __exports__